import * as t from 'io-ts';

/**
 * @file
 * Base implementation for complex stash values that should be merged using a last writer wins strategy.
 */

/*
 * Runtime types.
 */

export const RLastWriterWinsValue = t.type({
  updatedAt: t.number,
});

/*
 * Types.
 */

export type LastWriterWinsValue = t.TypeOf<typeof RLastWriterWinsValue>;

/*
 * Constants.
 */

export const defaultLastWriterWinsValue = {
  updatedAt: 0,
};

/*
 * Conflict resolution.
 */

export function mergeLastWriterWinsValue<T extends LastWriterWinsValue>(left: T, right: T): T {
  // Assumes that `updatedAt` is unlikely to collide.
  return left.updatedAt > right.updatedAt ? left : right;
}
